<template>
  <div class="wrapper">
    <div>
      <h2>New user login</h2>
      <p>Please enter pilot details</p>
      <PilotSettings @pilotEntered="pilotEntered = true" />
    </div>
    <transition name="fade-up">
      <div v-if="pilotEntered">
        <p>Please enter C.A.R.A:P.A.C.E. details</p>
        <CarapaceSettings @carapaceEntered="carapaceEntered = true" />
      </div>
    </transition>
    <transition name="fade-up">
      <button v-if="carapaceEntered" @click="initAndContinue" style="margin-top: 30px;">Complete setup and begin hibernation cycle</button>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import PilotSettings from '@/components/PilotSettings';
import CarapaceSettings from '@/components/CarapaceSettings';

export default {
  name: 'setup',
  components: {
    PilotSettings,
    CarapaceSettings
  },
  data() {
    return {
      pilotEntered: false,
      carapaceEntered: false,
    }
  },
  methods: {
    initAndContinue() {
      this.initCalendar();
      this.initCards();
      this.setNewGame(false);
      this.saveState();
      this.$router.push('/transition');
    },
    ...mapMutations([
      'initCalendar',
      'initCards',
      'setNewGame',
      'saveState',
    ]),
  },
}
</script>

<style scoped>
</style>
